export const T = {
  en_GB: {
    failedToUpdateGoal: "Failed to save goal",
    failedToCreateGoal: "Failed to create goal",
    failedToDeleteGoal: "Failed to delete goal",
  },
  nb_NO: {
    failedToUpdateGoal: "Kunne ikke lagre mål",
    failedToCreateGoal: "Kunne ikke opprette mål",
    failedToDeleteGoal: "Kunne ikke slette mål",
  },
} as const;
